import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export interface PageMetaProps {
  title: string;
  description: string;
  keywords?: string;
}

export const PageMeta: React.FC<PageMetaProps> = ({ title, description, keywords }) => {
  const { t } = useTranslation();

  return (
    <Helmet>
      <title>{t(title)} | CubersDen</title>
      <meta name="description" content={t(description)} />
      {keywords && <meta name="keywords" content={keywords} />}
    </Helmet>
  );
}; 